/*
  The picture behind the sign-in screen, in its light and dark versions.

  Theme system phase 3b, 14 September 2026; docs/THEME-SYSTEM.md section 6.
  `public/backgrounds/signin-light.svg` and `signin-dark.svg`, supplied by the
  owner with the theme system: eleven ribbons converging on the centre, so the
  card always has the calm middle under it, at any width down to a phone held
  upright.

  **The sign-in screen does not use a theme.** Nobody is identified there, so
  there is no theme to read, and no company or person can change it. Light or
  dark is the DEVICE's setting alone, chosen in CSS by prefers-color-scheme
  (`.login-wallpaper` in src/index.css), which also means the browser only ever
  fetches the one picture it is showing.

  **Two screens use it**, sign-in and setting a new password, which is why it
  lives here rather than inside either of them.

  **The file names are here rather than in the stylesheet** because a
  root-relative url() in a stylesheet under src/ is treated by the build as a
  module to resolve, and it fails: "Can't resolve '/backgrounds/...'". Files in
  public/ are addressed from JavaScript with PUBLIC_URL, handed to the stylesheet
  as two CSS variables.

  It replaced the owner's earlier sign-in picture (onhand-bg-signin.webp, 11
  September 2026) and the Phase 3 moving background that covered it; both were
  deleted from the repository on 14 September 2026.

  **The three amber ribbons in both pictures were recoloured blue on 15
  September 2026**, on the owner's word ("go with 5, ribbons in blue"): over the
  blue they turned khaki-brown and clashed with the logo's amber on the card.
  Same shapes and strengths; only the colours changed.
*/
const P = process.env.PUBLIC_URL || '';

export const SIGNIN_ART = {
  '--signin-art-light': `url("${P}/backgrounds/signin-light.svg")`,
  '--signin-art-dark': `url("${P}/backgrounds/signin-dark.svg")`,
};
